<a *ngIf="showFAQShortcut" pTooltip="FAQ" tooltipPosition="left" style="cursor: pointer; margin-top: -68px;" class="layout-config-button" (click)="goFaq()">
    <i id="icon-faq" class="pi pi-question-circle"></i>
</a>
